import React, { useRef, useState } from 'react';
import Card from '../Card/Card';
import './SoleCard.css';
import CardSnippet from './../../snippets/CardSnippet/CardSnippet';
import { Copy } from 'lucide-react';
const CardTitle = () => {
  return (
    <>
      card header
    </>
  )
}
const CardBody = () => {
  return (
    <>
      <p> Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime illo,
        veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem rerum
        nulla obcaecati, quidem, deleniti deserunt itaque odit officia!
      </p>
    </>
  )
}
const CardFooter = () => {
  return (
    <>
      <div className="carve-button-group">
        <button className="carve-button-vice carve-button-block">save</button>
        <button className="carve-button-main carve-button-block">cancel</button>
      </div>
    </>
  )
}
const SoleCard = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <div className="SoleCard" >
      <Card
        CardTitle={<CardTitle />}
        CardBody={<CardBody />}
        CardFooter={<CardFooter />}
      />
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <CardSnippet />
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy />
        </button>
      </div>
    </div>
  );
}

const NestCard = () => {
  return (
    <Card
      CardTitle='Card'
      CardBody={<SoleCard />}
    />
  );
}
SoleCard.propTypes = {};

export default NestCard;
